export default __webpack_public_path__ + "static/media/Sauna_HTB.348d4389.md";